module.exports = __webpack_public_path__ + "img/6.971d916f.svg";